import { Controller } from "@hotwired/stimulus"

// Asks before a save that turns strict privacy on (and only then: saving other privacy settings,
// or turning it off, goes straight through). Turbo shows the question when the form carries
// data-turbo-confirm, so the attribute is set only while the switch has been flipped on.
export default class extends Controller {
  static values = { message: String }

  connect() {
    this.checkbox = this.element.querySelector("input[type=checkbox][name='project[strict_privacy]']")
    if (!this.checkbox) return

    this.wasOn = this.checkbox.checked
    this.update = this.update.bind(this)
    this.checkbox.addEventListener("change", this.update)
  }

  disconnect() {
    this.checkbox?.removeEventListener("change", this.update)
  }

  update() {
    if (this.checkbox.checked && !this.wasOn) {
      this.element.dataset.turboConfirm = this.messageValue
    } else {
      delete this.element.dataset.turboConfirm
    }
  }
}
